/*
 * Copyright (c) 2023.
 */

import * as React from 'react';
import {lazy, Suspense} from "react";
import {HashRouter as Router, BrowserRouter, Routes, Route} from 'react-router-dom';
import VenditaAdd from "../pages/fatture/venditaAdd";
import VenditaEdit from "../pages/fatture/venditaEdit";

const Home = lazy(() => import("../pages/home"));
const Schede = lazy(() => import("../pages/schede/schede"));
const Edit = lazy(() => import("../pages/schede/edit"));
const Add = lazy(() => import("../pages/schede/add"));
const Single = lazy(() => import("../pages/schede/single"));
const List = lazy(() => import("../pages/schede/list"));
const Autori = lazy(() => import("../pages/autori/autori"));
const AutoriEdit = lazy(() => import("../pages/autori/autoriEdit"));
const AutoriNew = lazy(() => import("../pages/autori/autoriNew"));
const Opere = lazy(() => import("../pages/opere/opere"));
const OpereEdit = lazy(() => import("../pages/opere/opereEdit"));
const OpereNew = lazy(() => import("../pages/opere/opereNew"));
const Localizzazioni = lazy(() => import("../pages/localizzazioni/localizzazioni"));
const LocalizzazioniEdit = lazy(() => import("../pages/localizzazioni/localizzazioniEdit"));
const LocalizzazioniNew = lazy(() => import("../pages/localizzazioni/localizzazioniNew"));
const Gruppi = lazy(() => import("../pages/gruppi/gruppi"));
const GruppiEdit = lazy(() => import("../pages/gruppi/gruppiEdit"));
const GruppiNew = lazy(() => import("../pages/gruppi/gruppiNew"));
const Report = lazy(() => import("../pages/reports/index"));
const AutoreReport = lazy(() => import("../pages/reports/autore"));
const Vendita = lazy(() => import("../pages/fatture/vendita"));
const Acquisto = lazy(() => import("../pages/fatture/acquisto"));
const CenditaAdd = lazy(() => import("../pages/fatture/venditaAdd"));
const CenditaEdit = lazy(() => import("../pages/fatture/venditaEdit"));
const AcquistoAdd = lazy(() => import("../pages/fatture/acquistoAdd"));
const AcquistoEdit = lazy(() => import("../pages/fatture/acquistoEdit"));

export const Main = () => {

    return (
        <Suspense fallback={<div></div>}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Schede/>}/>
                    <Route path="/schede" element={<Schede/>}/>
                    <Route path="/scheda/single/:id" element={<Single/>}/>
                    <Route path="/schede/:id" element={<List/>}/>
                    <Route path="/scheda/aggiungi" element={<Add/>}/>
                    <Route path="/scheda/edit/:id" element={<Edit/>}/>
                    <Route path="/autori" element={<Autori/>}/>
                    <Route path="/autori/edit/:id" element={<AutoriEdit/>}/>
                    <Route path="/autori/aggiungi" element={<AutoriNew/>}/>
                    <Route path="/opere" element={<Opere/>}/>
                    <Route path="/opere/edit/:id" element={<OpereEdit/>}/>
                    <Route path="/opere/aggiungi" element={<OpereNew/>}/>
                    <Route path="/localizzazioni" element={<Localizzazioni/>}/>
                    <Route path="/localizzazioni/edit/:id" element={<LocalizzazioniEdit/>}/>
                    <Route path="/localizzazione/aggiungi" element={<LocalizzazioniNew/>}/>
                    <Route path="/gruppi" element={<Gruppi/>}/>
                    <Route path="/gruppi/edit/:id" element={<GruppiEdit/>}/>
                    <Route path="/gruppi/aggiungi" element={<GruppiNew/>}/>
                    <Route path="/reports" element={<Report/>}/>
                    <Route path="/reports/:id" element={<AutoreReport/>}/>
                    <Route path="/fatture/vendita" element={<Vendita/>}/>
                    <Route path="/fatture/acquisto" element={<Acquisto/>}/>
                    <Route path="/fatture/vendita/add" element={<VenditaAdd/>}/>
                    <Route path="/fatture/vendita/edit/:id" element={<VenditaEdit/>}/>
                    <Route path="/fatture/acquisto/add" element={<AcquistoAdd/>}/>
                    <Route path="/fatture/acquisto/edit/:id" element={<AcquistoEdit/>}/>
                </Routes>
            </BrowserRouter>
        </Suspense>
    );
};

export default Main;